import React from 'react'
import { useSetRecoilState } from 'recoil'
import { useAtomValueLoadable } from 'src/utils/jotai'
import { UserListItem } from 'src/common-services'
import { useAuthData } from 'src/components/auth/util'
import { browserLogger } from 'src/utils/browser-logger'
import { recentlyViewedClient } from 'src/clients'

import * as coreAtoms from 'src/v2/state/core'
import * as atoms from 'src/atoms/recently-viewed'

export function useSaveRecentEntity() {
  const setSaveDate = useSetRecoilState(atoms.lastSaveDate)
  const authData = useAuthData()
  const selectedEntityLoadable = useAtomValueLoadable(coreAtoms.selectedEntity)
  const selectedEntity = selectedEntityLoadable.state === 'hasData' ? selectedEntityLoadable.data : undefined

  React.useEffect(() => {
    if (!selectedEntity || !authData) {
      return
    }
    // For now, don't save areas or brands in recently viewed
    if (selectedEntity.type === 'SELECTED_AREA' || selectedEntity.type === 'SELECTED_BRAND') {
      return
    }
    recentlyViewedClient
      .addRecentlyViewed(selectedEntity)
      .then(() => {
        setSaveDate(new Date())
      })
      .catch((e) => browserLogger.error('could not save recently viewed entity', e))
  }, [selectedEntity])
}

export const useDeleteRecentlyViewed = () => {
  const setLastSaveDate = useSetRecoilState(atoms.lastSaveDate)

  return async (itemId: UserListItem['id']) => {
    if (!itemId) {
      return
    }
    try {
      await recentlyViewedClient.deleteRecentlyViewed(itemId)
      setLastSaveDate(new Date())
    } catch (e) {
      return
    }
  }
}

export const useDeleteAllRecentlyViewed = () => {
  const setLastSaveDate = useSetRecoilState(atoms.lastSaveDate)

  return async () => {
    try {
      await recentlyViewedClient.deleteAllRecentlyViewed()
      setLastSaveDate(new Date())
    } catch (e) {
      return
    }
  }
}
